import Modal from '../modal/modal';
import { FormTemplate } from '@employ-engage/data';
import AddTemplateToCompanyForm from '../add-template-to-company-form/add-template-to-company-form';
import InlineLoadingSpinner from '../inline-loading-spinner/inline-loading-spinner';
import { useTranslation } from 'react-i18next';

export interface AddTemplateToCompanyModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  templateSelectedForAddingToCompanyCollection: FormTemplate | null;
}

export function AddTemplateToCompanyModal({
  open,
  setOpen,
  templateSelectedForAddingToCompanyCollection,
}: AddTemplateToCompanyModalProps) {
  const { t } = useTranslation(['common']);
  return (
    <Modal
      open={open}
      setOpen={setOpen}
      panelClassName="bg-light-primaryBackground"
    >
      <div>
        <div className="flex flex-col items-center justify-center">
          <h1 className="text-3xl font-bold leading-9 text-gray-900">
            {t('Add Template to Company')}
          </h1>
          {templateSelectedForAddingToCompanyCollection ? (
            <AddTemplateToCompanyForm
              templateSelectedForAddingToCompanyCollection={
                templateSelectedForAddingToCompanyCollection
              }
              onClose={() => setOpen(false)}
            />
          ) : (
            <InlineLoadingSpinner />
          )}
        </div>
      </div>
    </Modal>
  );
}

export default AddTemplateToCompanyModal;
